export default {
	props: {
		max: {
			type: Number,
			default: 10,
		},
		modelValue: {
			type: Number,
			default: 1,
		},
	},
	emits: ['update:modelValue'],
	computed: {
		current: {
			get() {
				return this.modelValue
			},
			set(newValue) {

				this.$emit('update:modelValue', newValue)
			},
		},
	},
	template: `
    <div class="q-pa-lg flex flex-center">
        <q-pagination
        v-model="current"
        :max="max"
        :max-pages="5"
        direction-links
        flat
        />
  </div>
    `,
}
